const termFilter = term => object => {
  const loweredTerm = term.toLowerCase();
  return (
    object.title.toLowerCase().includes(loweredTerm) ||
    (object.description &&
      object.description.toLowerCase().includes(loweredTerm)) ||
    (object.data.designer &&
      object.data.designer.toLowerCase().includes(loweredTerm)) ||
    (object.data.colour &&
      object.data.colour.toLowerCase().includes(loweredTerm)) ||
    (object.data.patternNumber &&
      object.data.patternNumber.toLowerCase().includes(loweredTerm))
  );
};

const propertyFilter = filterValues => object => {
  return (
    Object.keys(filterValues)
      // Get only filters with values selected
      .filter(filterName => filterValues[filterName].length)
      // Apply filter to corresponding object data properties
      .reduce(
        (sum, filterName) =>
          sum && filterValues[filterName].includes(object.data[filterName]),
        true
      )
  );
};

export default function searchFilterAndSortGlass(
  objects,
  term,
  sortBy,
  filters = {}
) {
  const results = objects
    .filter(termFilter(term))
    .filter(propertyFilter(filters));

  if (sortBy === 'name:desc') {
    results.sort((a, b) => b.title.localeCompare(a.title));
  } else {
    // default to name:asc,  Name A - Z
    results.sort((a, b) => a.title.localeCompare(b.title));
  }

  return results;
}



// WEBPACK FOOTER //
// ./src/utils/search/glass.js